import PropertyLeftDrawerContainer from "../../../components/property/other/PropertyRightDrawer";

const PropertyLeftDrawer = () => {
  return <PropertyLeftDrawerContainer />;
};

export default PropertyLeftDrawer;
